/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2023-03-31 18:03:04
 * @Description: 
 */
import React, { ReactElement } from "react";
import style from './index.module.scss'

type PropsType = {
  children: ReactElement,
  height: number,
  width: number,
  className?: any,
  footer?: ReactElement
}

const WaterFallSon = (props: PropsType) => {
  return <div className={`${style['container-list']} ${props?.className ? props.className : ''}`}>
    <div className={`${style['container-list-image']}`}
      style={{ paddingTop: ((props.height / props.width) * 100).toFixed(4) + '%' }}>
      {props.children}
    </div>
    {props?.footer}
  </div>
}

export default WaterFallSon;